import React, { useContext, useEffect, useState } from "react";
import Box from "../../../setupPage/SharedComponents/Box";
import SetupContainer from "../../../setupPage/SharedComponents/SetupContainer";
import SetupTittle from "../../../setupPage/SharedComponents/SetupTittle";
import PaymentHistoryTable from "../../UserDashboard/SharedComponents/PaymentHistoryTable";
import axios from "axios";
import GetLocalStorageUserId from "../../../sharedComponents/GetLocalStorageuserId";
import DashboardPageTitle from "../../UserDashboard/SharedComponents/DashboardPageTitle";
import Swal from "sweetalert2";
import AutoCompleteBottomBorder from "../../SharedComponents/AutoCompleteBottomBorder";
import AgencyDashboardInput from "../SharedComponent/AgencyDashboardInput";
import SubmitBtn from "../../../setupPage/SharedComponents/SubmitBtn";
import { MdOutlineTextFields } from "react-icons/md";
import { contextProvider } from "../../../setupPage/SetupPagesContextApi/SetupPagesContextApi";

const CashPaymentAgent = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  useEffect(() => {
    axios
      .get(`${backendUrl}Payment/GetAgentPayments`)
      .then((res) => setFetchedData(res.data))
      .catch((err) => console.log(err.message));
  }, [backendUrl, refetch]);

  // input fields handle.
  const initialValue = {
    id: 1,
    paymentMethodId: "",
    paymentMethodName: "",
    parcelOderNo: "",
    orderAmount: "",
    description: "",
    paymentDate: "",
    paymentInvoiceNo: null,
    recordSerialNo: "", //
    parcelNoWithRecordSerialNo: "",
    creatorId: GetLocalStorageUserId(),
    creationDate: new Date(),
    modifierId: GetLocalStorageUserId(),
    modificationDate: new Date(),
  };

  const [formData, setFormData] = useState(initialValue);
  const [willUpdate, setWillUpdate] = useState(false);

  const update = (data) => {
    setFormData({ ...formData, ...data });
  };
  const{handleDataReload}=useContext(contextProvider)
  const formHandle = (e) => {
    e.preventDefault();
    formData.paymentDate = new Date(formData.paymentDate);
    console.log(formData);
    if (!willUpdate) {
      axios
        .post(`${backendUrl}Payment/CreatePayment`, { ...formData })

        .then((res) => {
          console.log(res);
          if (res.status === 201) {
            Swal.fire({
              title: `Cash Payment Created Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload()
          }
        })
        .catch((err) => console.log(err.message));
    }

    if (willUpdate) {
      console.log(formData);
      axios
        .put(`${backendUrl}Payment/CreatePayment/${formData.id}`, {
          ...formData,
        })

        .then((res) => {
          console.log(res);
          if (res.status === 204) {
            Swal.fire({
              title: `Cash Payment Updated Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload()
          }
        })
        .catch((err) => console.log(err.message));
    }
  };
  console.log(formData, "this is form dataaaaaaaaaaa.");
  return (
    <div>
      <Box top>
        <DashboardPageTitle text="Cash Paymen" />

        <SetupContainer>
          <form className="" onSubmit={formHandle}>
            <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
              <AgencyDashboardInput
                type="date"
                iconType="date"
                placeHolder="payment Date"
                allTimeValue={formData.paymentDate}
                valueUpdate={(e) => update({ paymentDate: e })}
              />
              <div className="w-full flex items-end">
                <div className="min-h-4 text-[#83430D] text-2xl p-2 shadow-xl">
                  <MdOutlineTextFields />
                </div>
                <AutoCompleteBottomBorder
                  valueUpdate={(_, value) => {
                    if (value?.parcelNo)
                      axios
                        .get(
                          `${backendUrl}ParcelDetails/GetParcelDetailsByParcelNo/${value?.parcelNo}`
                        )
                        .then((res) => {
                          update({
                            parcelOderNo: parseInt(value?.parcelNo),
                            description: res.data?.description,
                            orderAmount: res.data?.orderAmount,
                            paymentMethodId: res.data?.paymentTypeMethodId,
                            paymentMethodName:
                              res.data?.paymentMethodName || "Not Available",
                            parcelNoWithRecordSerialNo:
                              value.recordSerialNoWithParcelNo,
                            recordSerialNo: value.recordSerialNo,
                            paymentInvoiceNo: null,
                          });
                        });
                    else
                      update({
                        parcelOderNo: "",
                        description: "",
                        orderAmount: "",
                        paymentMethodId: "",
                        paymentMethodName: "",
                      });
                  }}
                  dataOf="currentUserParcelNumber"
                  placeholder="Parcel Number"
                  allTimeValue={formData.parcelOderNo}
                />
              </div>
              <AgencyDashboardInput
                disabled
                type="text"
                iconType="paymentMethod"
                placeHolder="payment Method"
                allTimeValue={formData.paymentMethodName}
                valueUpdate={(e) => update({ orderAmount: parseInt(e) })}
              />
              <AgencyDashboardInput
                disabled
                type="number"
                iconType="quantity"
                placeHolder="order Amount"
                allTimeValue={formData.orderAmount}
                valueUpdate={(e) => update({ orderAmount: parseInt(e) })}
              />
              <AgencyDashboardInput
                type="textArea"
                iconType="remark"
                placeHolder="description"
                allTimeValue={formData.description}
                valueUpdate={(e) => update({ description: e })}
              />
              {formData?.paymentMethodName !== "Cash" && (
                <AgencyDashboardInput
                  type="text"
                  iconType="invoice"
                  placeHolder="payment Invoice Number"
                  allTimeValue={formData?.paymentInvoiceNo}
                  valueUpdate={(e) => update({ paymentInvoiceNo: e })}
                />
              )}
            </div>

            <SubmitBtn
              page="agentDashboard"
              text={willUpdate ? "Update" : "Save"}
            />
          </form>
        </SetupContainer>
      </Box>

      <Box top></Box>
      <Box>
        <SetupContainer>
          <div className="text-end mb-6"></div>
          <PaymentHistoryTable // editCallBack={(data) => {
            //   update(data);
            //   setWillUpdate(true);
            // }}
            notEditAble
            fetchedData={fetchedData}
            headers={[
              "payment Date",
              "parcel order number",
              // "record Serial Number",
              // "payment Invoice No",
              "order Amount",
              "description",
              "payment Method Name",
            ]}
            row={[
              "paymentDate",
              "parcelNoWithRecordSerialNo",
              // "recordSerialNo",
              // "",
              "orderAmount",
              "description",
              "paymentMethodName",
            ]}
          />
        </SetupContainer>
      </Box>
    </div>
  );
};

export default CashPaymentAgent;
